import { useEffect } from "react";
import { CommonActions } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import type { ChatStackParamList } from "../../types";
import { getTestRouteTarget } from "../access/testRouteIds";

type Props = NativeStackScreenProps<ChatStackParamList, "TestDetail">;

export default function TestDetailScreen({ route, navigation }: Props) {
  const { testId } = route.params;

  useEffect(() => {
    const target = getTestRouteTarget(testId);
    const localState = navigation.getState();
    const hasOriginRoute = localState.index > 0;
    if (hasOriginRoute) {
      navigation.goBack();
    }
    navigation.getParent()?.dispatch(
      CommonActions.navigate({
        name: "Access",
        params: {
          screen: target.screen,
          params: {
            ...target.params,
            ...(hasOriginRoute
              ? { returnTab: route.params.returnTab ?? "Learn" }
              : {}),
          },
        },
      }),
    );
  }, [navigation, route.params.returnTab, testId]);

  return null;
}
